import React, { useEffect } from 'react'
import Navbars from '../../../Components/Navbar'
import { useNavigate } from 'react-router'
import lc from '../../../assets/LC.png'
import rc from '../../../assets/RC.png'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import firebaseConfig from '../../../Utilities/Firebase'
import { initializeApp } from 'firebase/app';
function Home() {
  const navigate = useNavigate()

  useEffect(() => {
    IsUserLogedIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function IsUserLogedIn() {
    const FirebaseApp = initializeApp(firebaseConfig);
    const auth = getAuth(FirebaseApp);
    onAuthStateChanged(auth, (user) => {
      if (user === null) {
        navigate('/');
      }
    });
  }


  return (
    <div>
      <Navbars type={'1'} />
      <br />
      <br />
      <br />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
        }}
      >
        <a href="/rc-accept" style={{ textAlign: "center" }}>
          <img src={rc} alt="rc" style={{ width: "50%", height: "50%" }}></img>
          <br />
          Railway
        </a>
        <a href="/lc-generate" style={{ textAlign: "center" }}>
          <img src={lc} alt="lc" style={{ width: "50%", height: "50%" }}></img>
          <br />
          Leaving certificate
        </a>
      </div>
    </div>
  )
}
export default Home
